(ns ncr.etc.zip
  (:require ["jszip" :as JSZip]
            ["jszip-utils" :as JSZipUtils]
            ["jszip/vendor/FileSaver" :as saveAs]
            [cljs.core.async :as async :refer-macros [go] :refer [<!]]
            [tick.core :as t]
            [ncr.etc.alert :as a]
            [ncr.etc.util :as u]
            [ncr.fragment.attachments-backend :as ba]))


(defn deduplicate-filenames [files]
  (map
    (fn [item filename]
      (assoc item :fileName filename))
    files
    (u/dedupe-with-fn
      #(let [[n e] (u/split-file-name %1)]
         (str n (when %2 (str " (" %2 ")")) e))
      (map :fileName files))))

(defn- get-metadata [fragments]
  (->> fragments
    (map
      (fn [{fragment-id :id :keys [attachments]}]
        (map #(-> % (select-keys [:id :fileName]) (assoc :fragment-id fragment-id)) attachments)))
    flatten
    (remove :deleted)
    deduplicate-filenames))

(defn no-downloadable-files? [fragments]
  (empty? (get-metadata fragments)))

(defn download! [{:keys [prefix attachments] :or {prefix "neckar_"}}]
  (go
    (let [^js zip (JSZip.)
          progress (a/progress nil)]
      (<!
        (a/!operation*
          {:operation-title "Creating archive" :success-title "Archive created"} progress
          (go
            (u/error-m
              [_
               (async/>! progress {:title "Creating archive..."})

               metadata
               (vec (deduplicate-filenames attachments))

               metadata-count
               (count metadata)

               _
               (<!
                 (let [ch (async/chan)]
                   (async/go-loop [idx 0 downloaded 0]
                     (if-let [{:keys [id fileName fragment-id]} (get metadata idx)]
                       (let [url (<! (ba/!download-url fragment-id id :ATTACHMENT))
                             blob (<! (u/promise->ch #(JSZipUtils/getBinaryContent url)))]
                         (recur (inc idx)
                           (+ downloaded
                             (when-not (and (sequential? blob) (= :error (first blob)))
                               (async/>! progress {:title (str "Adding file " (inc idx) " of " metadata-count)
                                                   :body fileName})
                               (.file zip fileName blob) 1))))
                       (async/>! ch (if (zero? downloaded) [:error "No files added"] downloaded))))
                   ch))

               zip-blob
               (<! (u/promise->ch #(.generateAsync zip #js {:type "blob"})))

               _
               (saveAs zip-blob
                 (str prefix (->> (t/instant) (t/zoned-date-time) (t/format "yyyy-MM-dd_HH-mm")) ".zip"))])))))))

(defn !download [_me fragments]
  (download!
    {:attachments
     (->> fragments
       (map
         (fn [{fragment-id :id :keys [attachments]}]
           (map #(-> % (select-keys [:id :fileName]) (assoc :fragment-id fragment-id)) attachments)))
       flatten
       (remove :deleted))}))
